import React from 'react';

export function Option(props: React.OptionHTMLAttributes<HTMLOptionElement>) {
  return <option {...props}></option>;
}

export function Select({ className, ...props }: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select className={`${className} rounded p-3 text-[0.875rem]`} {...props}></select>;
}
